<script>
	import { doLogout } from "src/store/auth/auth";
	import {
		Collapse,
		Dropdown,
		DropdownItem,
		DropdownMenu,
		DropdownToggle,
	} from "sveltestrap";

	export let className;
	export let isOpen = false;
	export let toggle;

	function handleUpdate(event) {
		isOpen = event.detail.isOpen;
	}
</script>

<Dropdown {isOpen} {toggle}>
	<DropdownToggle tag="div" class={"d-flex " + className}>
		<slot />
	</DropdownToggle>
	<DropdownMenu end>
		<DropdownItem>My Account</DropdownItem>
		<DropdownItem on:click={doLogout}>Logout</DropdownItem>
	</DropdownMenu>
</Dropdown>
